import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Clock, ArrowLeft, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      toast.success(data.message || "Check your inbox.");
      setSent(true);
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0D0C] grid-bg flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-9 h-9 rounded-lg bg-emerald-500 flex items-center justify-center"><Clock className="w-5 h-5 text-[#062217]" /></div>
          <span className="font-display text-2xl font-extrabold tracking-tight">QwikLogs</span>
        </Link>
        <div className="card-emerald p-8 animate-fade-up">
          {sent ? (
            <div className="text-center">
              <MailCheck className="w-12 h-12 text-emerald-500 mx-auto" />
              <h1 className="font-display text-2xl font-bold mt-4">Check your email</h1>
              <p className="text-sm text-muted-foreground mt-2">If that email is registered, we've sent a link to reset your password. It expires in 1 hour.</p>
            </div>
          ) : (
            <>
              <h1 className="font-display text-2xl font-bold">Reset your password</h1>
              <p className="text-sm text-muted-foreground mt-1">Enter your email and we'll send a reset link.</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <div>
                  <Label htmlFor="email">Work email</Label>
                  <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" className="mt-1.5 bg-[#0A0D0C] border-emerald-500/20" data-testid="forgot-email-input" />
                </div>
                <Button type="submit" disabled={busy} className="w-full bg-emerald-500 hover:bg-emerald-600 text-[#062217] font-semibold" data-testid="forgot-submit-btn">
                  {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
                </Button>
              </form>
            </>
          )}
        </div>
        <Link to="/login" className="flex items-center gap-1 justify-center text-sm text-muted-foreground hover:text-foreground mt-6">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
